/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { push } from "connected-react-router";
import { chain, values } from "lodash";
import * as React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";

import Products from "../../components/Products/Products";
import QuotationsSlider from "../../components/QuotationsSlider/QuotationsSlider";
import Statistics from "../../components/Statistics/Statistics";
import { User } from "../../models/User.model";
import { ActionHistory } from "../../types/ActionHistory";
import { Customer } from "../../types/Customer";
import { Quotation } from "../../types/Quotation";
import { RootState } from "../../types/RootState";
import { PageConnected } from "../Page/Page";
import { setCustomerQuotation } from "../../store/actions";

type PageHomeProps = {
    user: User;
    customers: { [customerId: string]: Customer };
    setCustomerQuotation: typeof setCustomerQuotation;
    push();
};
class PageHome extends React.Component<PageHomeProps> {
    public render() {
        const { customers } = this.props;

        const quotationsItems = chain(customers)
            .values()
            .map((c) =>
                values(c.quotations).map((q) => ({
                    quotation: q,
                    customer: c,
                }))
            )
            .flatten()
            .sortBy((a) => new Date(a.quotation.creationDate))
            .reverse()
            .value();

        const allQuotations = chain(customers)
            .values()
            .map((c) => values(c.quotations))
            .flatten()
            .reverse()
            .value();

        return (
            <PageConnected isHome={true}>
                <Products user={this.props.user} push={this.props.push} />
                {allQuotations.length > 0 && (
                    <QuotationsSlider
                        advisor={this.props.user}
                        quotations={quotationsItems}
                        onActionPerformed={(quotation: Quotation, actionHistory: ActionHistory, customerId: string) =>
                            this.onActionPerformed(quotation, actionHistory, customerId)
                        }
                    />
                )}
                {allQuotations.length > 0 && <Statistics quotations={allQuotations} />}
            </PageConnected>
        );
    }

    private onActionPerformed(quotation: Quotation, actionHistory: ActionHistory, customerId: string) {
        if (!quotation.actionHistory) {
            quotation.actionHistory = [];
        }
        quotation.actionHistory.push(actionHistory);
        this.props.setCustomerQuotation({ customerId, quotation });
    }
}

export const PageHomeConnected = compose(
    connect(
        (state: RootState, ownProps: any) => ({
            ...ownProps,
            user: state.me.user,
            customers: state.me.userData ? state.me.userData.customers : {},
        }),
        { push, setCustomerQuotation }
    )
)(PageHome);

// For stories
export const PageHomeStyled = PageHome;



// WEBPACK FOOTER //
// ./src/pages/PageHome/PageHome.tsx